module.exports = __webpack_public_path__ + "static/media/beginner-mark.9660bfb2.svg";